import api from 'api';

export const loadAffiliates = api(
  'GET /api/spend-adjustments/fields/affiliates'
);
export const loadApplications = api(
  'GET /api/spend-adjustments/fields/applications'
);
export const loadNetworks = api('GET /api/spend-adjustments/fields/networks');
export const loadPlatforms = api('GET /api/spend-adjustments/fields/platforms');
export const loadCampaigns = api('GET /api/spend-adjustments/fields/campaigns');
export const loadCurrencies = api(
  'GET /api/spend-adjustments/fields/currencies'
);
export const loadCountries = api('GET /api/spend-adjustments/fields/countries');
export const loadReasons = api('GET /api/spend-adjustments/fields/reasons');

export const loadTypes = (params) => {
  return api('GET /api/spend-adjustments/fields/types')(params);
};
export const loadStats = api('GET /api/spend-adjustments/fields/stats');
